import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ReportAssignmentListItem = ResultOf<
  typeof reportWorkOrderAssignmentListQuery
>["reportWorkOrderAssignments"][number];

export const reportWorkOrderAssignmentListQuery = graphql(`
  query ReportWorkOrderAssignmentList(
    $rangeStartDate: String!
    $rangeEndDate: String!
  ) {
    reportWorkOrderAssignments(
      range_start_date: $rangeStartDate
      range_end_date: $rangeEndDate
    ) {
      id
      assignment_status
      pickup_date
      delivery_date
      created_at
      work_order_id
      work_order_reference
      vehicle_type
      supplier_name
      departure_city
      delivery_city
      driver_name
      driver_email
      driver_phone
      driver_age
      pickup_hours_late
      delivery_hours_late
    }
  }
`);
